// Rezultatul unui examen (teorie sau practică) → tonul casetei (ReservationCardUI tone):
// promovat / terminat = success, respins / eroare = danger, în desfășurare / expirat = info.
export function examResultTone(status) {
   const s = String(status || "").toLowerCase();
   if (/pass|finish|complet|admis|promov/.test(s)) return "success";
   if (/fail|error|respins/.test(s)) return "danger";
   if (/progress|running|expired/.test(s)) return "info";
   return undefined;
}
